import { ApplicationView, useController } from '@aha-app/mvc';
import React from 'react';
import PresentationController from '../controllers/PresentationController';

const SidePanelTab: React.FC = () => {
  const controller = useController(PresentationController);

  if (!controller.hasFrames()) {
    return null;
  }

  return (
    <aha-sidepanel-item>
      <i className='fa-regular fa-presentation-screen' />
    </aha-sidepanel-item>
  );
};

export default ApplicationView(SidePanelTab);
